export default __webpack_public_path__ + "static/media/abacus.303aa3f1.png";